import { apiSearch } from './utility';

const SEARCHING_GAS_FORMULAS = 'gasFormula/SEARCHING';
const GAS_FORMULA_SEARCH_FAILED = 'gasFormula/SEARCH_FAILED';

const initialState = {
	isSearching : false,
	searchFailed : false,
};

//- Reducers
export default (state = initialState, action) => {

	switch (action.type) {
		case SEARCHING_GAS_FORMULAS:
			return {
				...state,
				isSearching: true
			};
		case GAS_FORMULA_SEARCH_FAILED:
			return {
				...state,
				searchFailed : true,
			};
		default:
			return state;
	}
};

export const search = () => {
	return dispatch => {
		dispatch({
			type: SEARCHING_GAS_FORMULAS
		});

		apiSearch({
			base : 'gasFormula',
			dispatch : dispatch,
			callback : function(err) {
				if (err) {
					dispatch({
						type: GAS_FORMULA_SEARCH_FAILED,
					});
				}
			}
		});
	};
};
